import React from "react";
import MyInput from "../Interactions/MyInput";
import MyPassword from "../Interactions/PasswordInput";
import MyDatePicker from "../Interactions/MyDatePicker";
import MyTimePicker from "../Interactions/MyTimePicker";
import MyTextArea from "../Interactions/MyTextArea";
import MyDropDown from "../Interactions/MyDropDown";
import IntegerInput from "../Interactions/IntegerInput";
import PhoneNumInput from "../Interactions/PhoneNumInput";
import MyCheckbox from "../Interactions/MyCheckbox";
import { MailOutlined } from "@ant-design/icons";
import MyFileUpload from "../Interactions/MyFileUpload";
import MySelectDropdown from "../Interactions/MySelectDropdown";
import country from "../../utils/country.json";
import dayjs from "dayjs";
import { PencilIcon } from "../../utils/icons";

// const PencilIcon = () => (
//   <svg
//     width="17"
//     height="17"
//     viewBox="0 0 17 17"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M3.16797 13.8322H5.83464L12.8346 6.83223C13.571 6.09585 13.571 4.90195 12.8346 4.16557C12.0983 3.42919 10.9043 3.42919 10.168 4.16557L3.16797 11.1656V13.8322"
//       stroke="#8F8F8F"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M9.5 4.83203L12.1667 7.4987"
//       stroke="#8F8F8F"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

const CurrentInput = ({
  data,
  formInputData,
  indexNum,
  onChange = () => {},
  value,
  isDisabled = false,
}) => {
  const { name, placeholder, ...rest } = data;
  console.log(formInputData, " = valuuueesssss:va:formInputData");
  if (rest.type === "TextInput") {
    return (
      <MyInput
        icon={<PencilIcon />}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value, name)}
        value={formInputData[name]}
        disabled={isDisabled}
      />
    );
  }
  if (rest.type === "Upload") {
    // const splited = name?.split(".");
    // console.log(name, "Uploadnameeeeeeeeteeeeeeeee", formInputData[splited[0]][splited[1]]);
    return (
      <MyFileUpload
        type="noGradient"
        // name={data.name}
        action={rest.action} // URL to upload the file
        accept={rest.accept}
        // listType={data.listType}
        // maxCount={data.maxCount}
        placeholder={placeholder}
        onChange={(file) => onChange(file, name)}
        value={formInputData[name]}
        // onChange={(info) => handleChangeInput(info)} // Implement this function to handle changes
        // Other upload props as needed
      />
    );
  }
  if (rest.type === "Email") {
    return (
      <MyInput
        icon={<MailOutlined style={{ color: "#8F8F8F" }} />}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value, name)}
        value={formInputData[name]}
        disabled={isDisabled}
      />
    );
  }
  if (rest.type === "Password") {
    return (
      <MyPassword
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value, name)}
        value={formInputData[name]}
      />
    );
  }
  if (rest.type === "PhoneInput") {
    return (
      <PhoneNumInput
        placeholder={placeholder}
        value={formInputData[name]}
        onChange={(value) => onChange(value, name)}
        disabled={isDisabled}
      />
    );
  }
  if (rest.type === "Date") {
    console.log(formInputData[name], "formInputData[name]");
    return (
      <MyDatePicker
        placeholder={placeholder}
        value={formInputData[name] ?? null}
        onChange={(date, dateStr) => onChange(date, name)}
        disabled={isDisabled}
      />
    );
  }
  if (rest.type === "Dropdown") {
    // return <MyDropDown selectedValue={rest.placeholder} />
    return (
      <MyDropDown
        selectedValue={formInputData[name] || placeholder}
        // selectedValue={formInputData[name]}
        items={rest.items}
        onChange={(value) => onChange(value, name)}
        // selectedValue={formInputData[name]}
      />
    );
  }
  if (rest.type === "Time") {
    return <MyTimePicker value={value} />;
  }
  if (rest.type === "TextArea") {
    return (
      <MyTextArea
        placeholder={placeholder}
        value={formInputData[name]}
        onChange={(value) => onChange(value, name)}
        {...rest}
      />
    );
  }
  if (rest.type === "Select") {
    console.log(name, " =nameeeeeeessssssssssss");
    if (name.includes("City")) {
      let newCityName = "City",
        newCountryName = "Country";
      if (indexNum !== undefined && indexNum !== null && indexNum !== -1) {
        newCityName = `City${indexNum}`;
        newCountryName = `Country${indexNum}`;
      }

      let selectedCountry = {};
      if (formInputData && formInputData[newCountryName]) {
        selectedCountry = country.find(
          (ct) => ct.label === formInputData[newCountryName]
        );
        // console.log(selectedCountry.cities, " = citiesssss", formInputData);
      }
      return (
        <MySelectDropdown
          placeholder={placeholder}
          onChange={(value) => onChange(value, name)}
          {...rest}
          value={formInputData[newCityName] ?? null}
          disabled={
            selectedCountry?.length === 0 && !formInputData[newCityName]
          }
          options={selectedCountry?.cities?.map((city) => ({
            label: city,
            value: city,
          }))}
        />
      );
    }
    return (
      <MySelectDropdown
        placeholder={placeholder}
        value={formInputData[name]}
        onChange={(value) => onChange(value, name)}
        {...rest}
      />
    );
  }
  if (rest.type === "Checkbox") {
    return (
      <div className="w-full flex items-center justify-center">
        <MyCheckbox
          onChange={(value) => onChange(value, name)}
          value={formInputData[name]}
          {...rest}
        />
      </div>
    );
  }
  if (rest.type === "File") {
    return (
      <div className="myUploadWidth w-full flex items-center justify-center">
        <MyFileUpload
          onChange={(value) => onChange(value, name)}
          placeholder={placeholder}
          {...rest}
        />
      </div>
    );
  }
};

export default CurrentInput;
